import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from "./components/Header";
import Footer from './components/Footer';
import EnquiryPopup from "./components/EnquiryPopup";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import BookServices from "./pages/BookService";
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/Terms & Conditions';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/book-service'element={<BookServices/>}/>
           <Route path='/privacypolicy'element={<PrivacyPolicy/>}/>
            <Route path='/termsconditions'element={<TermsConditions />}/>
        </Routes>
        <Footer />
        <EnquiryPopup />
      </div>
    </Router>
  );
}

export default App;